import TWEEN from '@tweenjs/tween.js'

export default class Content {
	private readonly tweens: any[] = []
	private readonly element: HTMLDivElement
	private readonly items: HTMLDivElement[]
	private index = 0

	constructor(element) {
		this.element = element
		this.items = Array.from(this.element.querySelectorAll('.js-content-item'))
	}

	get rect() {
		return this.element.getBoundingClientRect()
	}

	hide() {
		this.index = 0
		this.items.forEach((item) => {
			item.style.display = 'none'
			item.style.visibility = 'hidden'
		})
		this.items[this.index].style.display = 'block'
	}

	show(index = 0) {
		this.index = index
		this.items.forEach((item) => (item.style.visibility = 'hidden'))
		this.items[this.index].style.visibility = 'visible'
		this.animate()
	}

	showItem(id) {
		const index = this.items.findIndex((node) => node.dataset.id === id)
		this.items.forEach((item) => (item.style.display = 'none'))
		this.items[index].style.display = 'block'
		this.show(index)
	}

	animate() {
		this.tweens.forEach((tween) => tween.stop())
		this.tweens.length = 0

		const title = this.items[this.index].children[0] as HTMLElement
		const text = this.items[this.index].children[1] as HTMLElement

		title.style.opacity = '0'
		text.style.opacity = '0'

		this.tweens.push(
			new TWEEN.Tween({ y: 2, opacity: 0 })
				.to({ y: 0, opacity: 1 }, 500)
				.easing(TWEEN.Easing.Exponential.Out)
				.onUpdate(({ y, opacity }) => {
					title.style.transform = `translateY(${y}em)`
					title.style.opacity = `${opacity}`
				})
				.start()
		)

		this.tweens.push(
			new TWEEN.Tween({ y: 2, opacity: 0 })
				.to({ y: 0, opacity: 1 }, 500)
				.delay(250)
				.easing(TWEEN.Easing.Exponential.Out)
				.onUpdate(({ y, opacity }) => {
					text.style.transform = `translateY(${y}em)`
					text.style.opacity = `${opacity}`
				})
				.start()
		)
	}
}
